import { useEffect, useRef } from 'react';

export function useSyncQueryParamToState(
  queryParam: string | null | undefined,
  setLocalQuery: (value: string) => void,
): void {
  const previousQueryParamRef = useRef(queryParam);

  useEffect(() => {
    if (queryParam === previousQueryParamRef.current) {
      return;
    }

    previousQueryParamRef.current = queryParam;
    setLocalQuery(queryParam ?? '');
  }, [queryParam]);
}
